import { Chip } from '@mui/material';
import { colors } from '@sweep-io/sweep-design';
import { Close } from '@sweep-io/sweep-design/dist/icons';
import React from 'react';

export type ColorVariant = Extract<keyof typeof colors, 'blue' | 'blush' | 'gum' | 'lemon' | 'lilac' | 'mint' | 'seafoam' | 'sky' | 'sun'>;

interface FancyTagProps {
  text: string;
  colorVariant?: ColorVariant;
  onDelete?: () => void;
  startIcon?: React.ReactNode;
}


const FancyTag = ({ text, colorVariant = 'blue', onDelete, startIcon }: FancyTagProps) => {
  const backgroundColor = colors[colorVariant][100];
  const textColor = colors[colorVariant][500];

  return (
    <Chip
      label={text}
      onDelete={onDelete}
      deleteIcon={
        onDelete ? (
          <Close size="small" color={textColor} />
        ) : undefined
      }
      icon={startIcon ? <React.Fragment>{startIcon}</React.Fragment> : undefined}
      sx={{
        backgroundColor,
        border: `1px solid ${textColor}`,
        borderRadius: '8px',
        minHeight: '32px',
        color: textColor,
        fontWeight: 400,
        fontSize: '14px',
        '& .MuiChip-label': {
          padding: startIcon ? '0 8px 0 4px' : '0 8px',
        },
        '& .MuiChip-icon': {
          color: textColor,
          marginLeft: '8px',
          marginRight: '-4px',
        },
        '& .MuiChip-deleteIcon': {
          color: textColor,
          marginRight: '8px',
          '&:hover': {
            color: textColor,
            opacity: 0.7,
          },
        },
      }}
    />
  );
};

export default FancyTag;
